import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {QueryParamsModel, QueryResultsModel} from '../../../_base/crud';
import {MainService} from '../main.service';
import {AuthService} from '../auth.service';
import {UtilisateurModel} from '../../../models/main/utilisateur.model';
import {ToastrService} from 'ngx-toastr';

const API_URL = 'utilisateur/';


@Injectable()

export class UtilisateurService extends MainService {


	constructor(http: HttpClient,
				toast: ToastrService,
				private authService: AuthService) {
		super(http, toast);
	}

	// find
	find(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		let login = this.authService.recupererLoginDuLocal();
		return this.httpPost(API_URL + 'find/' + login.id, queryParams,);
	}

	// create
	create(utilisateur: UtilisateurModel): Observable<UtilisateurModel> {
		return this.httpPost(API_URL, utilisateur);
	}

	// update
	update(utilisateur: UtilisateurModel): Observable<UtilisateurModel> {
		return this.httpPatch(API_URL + utilisateur.id, utilisateur);
	}

	// delete
	delete(id: number): Observable<string> {
		return this.httpDelete(API_URL + id);
	}

	// changer mot de passe
	changepassword(utilisateur: number, data: any): Observable<string>  {
		/*
		data = { motdepasse: '', nouveaumotdepasse: '', envoyermotdepasse: true/false }
		 */
		return this.httpPost(API_URL + 'changermotdepasse/'+utilisateur,data);
	}

	// getOne
	getOne(id: number): Observable<UtilisateurModel> {
		return this.httpGet(API_URL + id);
	}






}
